import React from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import './App.scss';
import { Route, Router, Switch } from 'react-router-dom';
import LoadingOverlay from 'react-loading-overlay';
import { useQuery } from 'react-apollo';
import { GET_LOADER } from './graphql-client/queries';
import { PublicRoutes, PrivateRoutes } from './routes';
import { history, routeConstants, loaderStyle } from './utils';

function Main() {
  const { data } = useQuery(GET_LOADER);
  return (
    <LoadingOverlay
      active={data && data.loader && data.loader.show}
      spinner
      text=""
      className="mainLoader"
      styles={loaderStyle}
    >
      <div className="page-wrapper">
        <div>
          <Router history={history}>
            <Switch>
              <Route path={`${routeConstants.DASHBOARD}`} component={PrivateRoutes} />
              <Route path={`${routeConstants.CREATE_PASSWORD}`} component={PrivateRoutes} />
              <Route path={`${routeConstants.ADMIN_ARTIST}`} component={PrivateRoutes} />
              <Route path={`${routeConstants.ADMIN_MANAGER}`} component={PrivateRoutes} />
              <Route path={`${routeConstants.QUESTIONNAIRE}`} component={PrivateRoutes} />
              <Route path={`${routeConstants.ADMIN_OFFER}`} component={PrivateRoutes} />
              <Route path={`${routeConstants.OFFER_DETAIL}`} component={PrivateRoutes} />
              <Route path={`${routeConstants.ADMIN_ANALYTICS}`} component={PrivateRoutes} />
              <Route path="/" component={PublicRoutes} />
            </Switch>
          </Router>
        </div>
      </div>
    </LoadingOverlay>
  );
}

export default Main;
